import React from 'react'

const BookAppointment = () => {
  return (
    <div>BookAppointment</div>
  )
}

export default BookAppointment